import { render, staticRenderFns } from "./videoRealTime.vue?vue&type=template&id=c826e692&scoped=true"
import script from "./videoRealTime.vue?vue&type=script&lang=js"
export * from "./videoRealTime.vue?vue&type=script&lang=js"
import style0 from "./videoRealTime.vue?vue&type=style&index=0&id=c826e692&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c826e692",
  null
  
)

export default component.exports